import cls from "classnames";
import dayjs from "dayjs";

import { useState } from "react";

import { Box, Link, Typography, Tooltip, IconButton } from "@mui/material";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import SitemapDialog from "@/components/SitemapDialog";
import SitemapDialogBtn from "@/components/SitemapDialog";
import { AIRPORT_MAP, PROGRAM_TEXT } from "@/constants/airport";
import { airlineBgColor } from "@/constants/config";
import useThemeData from "@/hooks/useThemeData";
import { FlightItem } from "@/typings";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpIcon from '@mui/icons-material/Help';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import BackHandIcon from '@mui/icons-material/BackHand';
import usePlatform from "../usePlatform";
import Products from "./Products";
import { PROGRAM_NAME_MAP } from "@/constants/programs";
// dayjs.extend(relativeTime);
// dayjs.extend(updateLocale);

// dayjs.updateLocale("en", {
//   relativeTime: {
//     future: "in %s",
//     past: "%s",
//     // s: "seconds",
//     // m: "1 minute",
//     // mm: "%d minutes",
//     s: "Live",
//     ss: "Live",
//     m: "Live",
//     mm: function (value: number) {
//       return value <= 18 ? "Live" : "mins ago";
//     },
//     h: "1 hr ago",
//     hh: "%d hrs ago",
//     d: "1 day ago",
//     dd: "%d days ago",
//     M: "1 month ago",
//     MM: "%d months ago",
//     y: "1 year ago",
//     yy: "%d years ago",
//   },
// });

interface SummaryAirlineProps {
  data: FlightItem;
  className?: string;
}

const airportDisplay = (airport_code: string) => {
  return AIRPORT_MAP[airport_code].name;

  // return airport_code;
};

const SummaryAirline = (props: SummaryAirlineProps) => {
  const { data } = props;
  const theme = useThemeData();

  const { isPc } = usePlatform();

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const alertDetailPage = window.location.pathname === "/alert-detail";

  const products = data.fare.products;
  const last_seen_time = data.l_s;
  return (
    <div
      className={cls([
        "flex flex-col justify-between md:p-[6px] md:pt-[12px] md:pb-[0px]",
        props.className,
      ])}
    >
      <div
        className="flex justify-between items-center md:m-[-6px] md:p-[6px]  !mb-[-20px]"
      // style={{ backgroundColor: theme.isDarkMode ? airlineBgColor : "rgb(245, 245, 245)" }}
      >

        <Typography fontSize={18} className="md:px-[6px] md:text-center">
          {dayjs(products[0].departure_time).format("hh:mmA")}
          <span className="text-[13px] block mt-[-2px]">
            {dayjs(products[0].departure_time).format("ddd")}{" "}
            {dayjs(products[0].departure_time).format("MM/DD")}

          </span>
        </Typography>
        <div className="flex-1 flex justify-center items-center space-x-[6px]">
          <div className="flex flex-col items-center">

            <div>
              <Typography className="inline-flex items-center">
                {data.fare.travel_time_display.replace("h", "hr").replace("m", "min")} • {products.length === 1 ? "Nonstop" : `${products.length - 1} stop`}
              </Typography>
            </div>
          </div>
        </div>
        <Typography className="text-right md:px-[6px] md:text-center" fontSize={18}>
          {dayjs(products[products.length - 1].arrival_time).format("hh:mmA")}
          <span className="text-[13px] block mt-[-2px]">
            {dayjs(products[products.length - 1].arrival_time).format("ddd")}{" "}
            {dayjs(products[products.length - 1].arrival_time).format("MM/DD")}
          </span>
        </Typography>
      </div>

      <div className="pt-[10px] pb-[20px] md:px-[20px] mt-[10px]">
        {/* <div className="flex justify-between mb-[-2px]">
          <Tooltip title={airportDisplay(products[0].origin)} placement="top">
            <Typography fontSize={18}>{products[0].origin}</Typography>
          </Tooltip>
          <Tooltip
            title={airportDisplay(products[products.length - 1].destination)}
            placement="top"
          >
            <Typography fontSize={18}>{products[products.length - 1].destination}</Typography>
          </Tooltip>
        </div> */}

        <Products data={props.data} />
      </div>

      {isPc && (
        <div className="mt-[0px] px-[3px] mb-[5px] flex justify-between items-center">
          <div className="flex items-center">
            <Tooltip title="Last seen time" placement="top">
              <div className="flex items-center mr-[5px] rounded-md px-2 py-0"
                style={{ borderWidth: '2px', borderStyle: 'solid', borderColor: theme.isDarkMode ? "#424242" : "#f5f5f5" }}>
                {/* <AccessTimeIcon fontSize="small" className="mr-[3px] !text-[14px]" /> */}
                {dayjs(last_seen_time * 1000).fromNow() == "Live" || dayjs(last_seen_time * 1000).fromNow() == "just now" || !alertDetailPage ?
                  <span className="relative mx-[0px] mr-[10px] flex h-[6px] w-[6px]">
                    <span className="absolute -left-[3px] -top-[3px] inline-flex h-[12px] w-[12px] animate-[ping_2s_ease-in-out_infinite] rounded-full opacity-75" style={{ backgroundColor: theme.palette.primary.main }}>
                    </span>
                    <span className={theme.isDarkMode ? "relative inline-flex h-[6px] w-[6px] rounded-full ring-[1px] ring-offset-[2px]" : "relative inline-flex h-[6px] w-[6px] rounded-full bg-[#1976d2] ring-[1px] ring-[#1976d2] ring-offset-[2px]"}
                      style={{
                        backgroundColor: theme.palette.primary.main,
                        '--ring-color': theme.palette.primary.main
                      }}>
                    </span>
                  </span> : <AccessTimeIcon fontSize="small" className="mr-[3px] !text-[14px]" />}
                <Typography fontSize={12} className="mr-[3px]">{alertDetailPage ? dayjs(last_seen_time * 1000).fromNow() : "Live"}</Typography>
              </div>
            </Tooltip>
            {PROGRAM_TEXT[data.program_code] && <Tooltip
              title={PROGRAM_TEXT[data.program_code]?.join(" ")}
              placement="top"
            >
              <IconButton
                size="small"
                sx={{
                  // backgroundColor: theme.isDarkMode ? "#424242" : "#f5f5f5",
                  padding: "4px",
                }}
              >
                <CheckCircleOutlineIcon fontSize="small" className="!text-[14px]" />
              </IconButton>
            </Tooltip>}
          </div>

          <SitemapDialogBtn data={data} />
        </div>
      )}
    </div>
  );
};
export default SummaryAirline;
